module.exports = __webpack_public_path__ + "img/logo-all-dark.6734d368.svg";